<template>
  <div class="data-stats">
    <div class="stat-item" v-for="(item, index) in statsList" :key="index">
      <div class="stat-title">{{ item.title }}</div>
      <div class="stat-number">{{ item.number }}</div>
      <div class="stat-desc">{{ item.desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataStats',
  data() {
    return {
      statsList: [
        { title: '深耕', number: '8年+', desc: '评价领域' },
        { title: '累计组织', number: '500场+', desc: '成果评价' },
        { title: '建设', number: '1000位+', desc: '专家智库' },
        { title: '拥有', number: '100位+', desc: '合作伙伴' }
      ]
    }
  }
}
</script>

<style scoped>
.data-stats {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  width: 100%;
  margin: 40px auto;
  padding: 0 20px;
  gap: 20px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.stat-item {
  flex: 1;
  text-align: center;
  padding: 10px 0;
}
.stat-title {
  font-size: 28px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 12px;
  line-height: 1.2;
}
.stat-number {
  font-size: 34px;
  font-weight: 700;
  background: linear-gradient(90deg, #348FE2 0%, #0052D9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 12px;
  line-height: 1.1;
}
.stat-desc {
  font-size: 18px;
  color: #999999;
  line-height: 1.3;
}
@media (max-width: 1200px) {
  .data-stats {
    padding: 0 15px;
  }
  .stat-title {
    font-size: 22px;
  }
  .stat-number {
    font-size: 36px;
  }
  .stat-desc {
    font-size: 16px;
  }
}
@media (max-width: 992px) {
  .stat-title {
    font-size: 20px;
  }
  .stat-number {
    font-size: 32px;
  }
  .stat-desc {
    font-size: 16px;
  }
}
@media (max-width: 768px) {
  .data-stats {
    flex-direction: column;
    gap: 35px;
    padding: 30px 15px;
    margin: 20px auto;
  }
  .stat-item {
    width: 100%;
  }
  .stat-title {
    font-size: 24px;
    margin-bottom: 8px;
  }
  .stat-number {
    font-size: 42px;
    margin-bottom: 8px;
  }
  .stat-desc {
    font-size: 18px;
  }
}
@media (max-width: 480px) {
  .stat-title {
    font-size: 22px;
  }
  .stat-number {
    font-size: 38px;
  }
  .stat-desc {
    font-size: 16px;
  }
}
</style>